"use strict";

var _defineProperty = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var operators_1 = require("rxjs/operators");

var UniqueBehaviorSubject_1 = require("../UniqueBehaviorSubject");

var AttributesProxySubject = /*#__PURE__*/function () {
  function AttributesProxySubject() {
    var _this = this;

    var attributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, AttributesProxySubject);

    var schema = options.schema,
        prepare = options.prepare;
    this.attributes$ = new UniqueBehaviorSubject_1.UniqueBehaviorSubject(attributes, {
      prepare: prepare
    });

    if (schema) {
      var _loop = function _loop(name) {
        if (schema.hasOwnProperty(name)) {
          var _Object$assign = Object.assign({
            subject: false,
            getter: false,
            setter: false
          }, schema[name] === true ? {
            subject: true,
            getter: true,
            setter: true
          } : schema[name]),
              subject = _Object$assign.subject,
              setter = _Object$assign.setter,
              getter = _Object$assign.getter;

          if (subject) {
            var subject$ = _this.getAttribute$(name);

            Object.defineProperty(_this, "".concat(name, "$"), {
              get: function get() {
                return subject$;
              }
            });
          }

          Object.defineProperty(_this, name, Object.assign({}, getter ? {
            get: function get() {
              return _this.getAttribute(name, null);
            }
          } : {}, setter ? {
            set: function set(value) {
              return _this.setAttribute(name, value);
            }
          } : {}));
        }
      };

      for (var name in schema) {
        _loop(name);
      }
    }
  }

  _createClass(AttributesProxySubject, [{
    key: "getAttribute$",
    value: function getAttribute$(name) {
      var _this2 = this;

      var result = new UniqueBehaviorSubject_1.UniqueBehaviorSubject();
      this.attributes$.pipe(operators_1.map(function (attributes) {
        return attributes ? attributes[name] : null;
      })).subscribe(result);
      result.subscribe(function (value) {
        return _this2.setAttribute(name, value);
      });
      return result;
    }
  }, {
    key: "getAttribute",
    value: function getAttribute(name) {
      var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return this.attributes && typeof this.attributes[name] !== "undefined" ? this.attributes[name] : defaults;
    }
  }, {
    key: "setAttribute",
    value: function setAttribute(name, value) {
      this.attributes = Object.assign({}, this.attributes || {}, _defineProperty({}, name, value));
    }
  }, {
    key: "updateAttributes",
    value: function updateAttributes(attributes) {
      this.attributes = attributes ? Object.assign({}, this.attributes || {}, attributes) : null;
    }
  }, {
    key: "attributes",
    get: function get() {
      return this.attributes$.value;
    },
    set: function set(attributes) {
      this.attributes$.next(attributes);
    }
  }]);

  return AttributesProxySubject;
}();

exports.AttributesProxySubject = AttributesProxySubject;